/**
 * How a file type's icon looks.
 */
export interface IconType {
  expr: RegExp
  color: string
  type: 'text' | 'table' | 'image' | 'code' | 'slides'
}

const fileTypes: IconType[] = [
  {
    expr: /(xlsx?|numbers)/i,
    color: '#70c79a',
    type: 'table',
  },
  {
    expr: /(png|jpe?g|tiff|gif)/i,
    color: '#40a0f4',
    type: 'image',
  },
  {
    expr: /(js|cs|java|md|c|py|ts)/i,
    color: '#999',
    type: 'code',
  },
  {
    expr: /(pptx?|key)/i,
    color: '#FF5252',
    type: 'slides',
  },
  {
    expr: /.*/,
    color: '#FF5252',
    type: 'text',
  },
]

/**
 * Gets the icon look for the file type or name, falling back to text.
 *
 * @param fileType
 */
export function getFileIconType(fileType = ''): IconType {
  return (
    fileTypes.find((opts) => opts.expr.test(fileType)) ??
    fileTypes[fileTypes.length - 1]
  )
}
